import React, { useEffect, useRef } from 'react';
import { Rng } from './rand.mjs';
import { names5 } from './names.mjs';
import { createCharacter2, createFixedCharacter2 } from './character2.mjs';
import { entityAlly } from './mission0.mjs';
import { roles, rolesBykey } from './data/google/processor/data_char2roles.mjs';
import { L } from './localization.mjs';

import './FigmaIngameView.css';

import { PortraitWrapper } from './PortraitsView.js';
import { RenderAgentSimple } from './RenderAgentSimple.js';

import { v2 } from './v2.mjs';
import { roleIcons } from './RenderAgentSimple.js';

const filter_color_perset = {
  red: 'invert(18%) sepia(41%) saturate(7500%) hue-rotate(353deg) brightness(106%) contrast(126%)',
  green: 'invert(45%) sepia(86%) saturate(1713%) hue-rotate(84deg) brightness(125%) contrast(121%)',
};

const hotKeyButtonUnion = <svg className='union-svg' xmlns="http://www.w3.org/2000/svg" width="74" height="62" viewBox="0 0 74 62" fill="none">
  <path className='union-path' opacity="0.7" d="M12.013 0.711429C9.89131 0.711429 7.85649 1.55429 6.35619 3.05455L2.34319 7.06758C0.842855 8.56788 0 10.6027 0 12.7245V49.5536C0 51.6754 0.842872 53.7102 2.34319 55.2105L6.35631 59.2236C7.85661 60.7239 9.89143 61.5668 12.0131 61.5668L48.8424 61.5668C50.9641 61.5668 52.999 60.7239 54.4992 59.2236C57.8626 55.8603 61.2183 52.4702 64.5699 49.0844L64.5718 49.0825C67.0235 46.6057 69.473 44.1311 71.9215 41.671L71.9229 41.6696C72.8534 40.7329 73.3756 39.4662 73.3756 38.1458V24.1649C73.3756 22.8446 72.8534 21.5778 71.9229 20.6411L71.9212 20.6395C69.3231 18.03 66.7192 15.3922 64.1118 12.7507C60.9119 9.50893 57.7061 6.26132 54.4994 3.05456C52.9991 1.55428 50.9643 0.711426 48.8425 0.711426L12.013 0.711429Z" fill="black" />
</svg>

const hotKeyHealButtonIntersect = <svg className='intersect-svg' xmlns="http://www.w3.org/2000/svg" width="55" height="56" viewBox="0 0 55 56" fill="none">
  <path className='intersect-path' d="M2.17157 6.52066C1.42143 7.2708 1 8.28822 1 9.34908V46.1783C1 47.2392 1.42143 48.2566 2.17157 49.0068L6.18451 53.0197C6.93465 53.7699 7.95207 54.1913 9.01294 54.1913H45.8425C46.9034 54.1913 47.9208 53.7699 48.671 53.0197L52.6838 49.0069C53.4339 48.2568 53.8553 47.2393 53.8553 46.1785V9.34896C53.8553 8.2881 53.4339 7.27068 52.6838 6.52054L48.6707 2.50751C47.9206 1.75736 46.9032 1.33594 45.8423 1.33594H9.01315C7.95228 1.33594 6.93487 1.75736 6.18472 2.50751L2.17157 6.52066Z" fill="url(#paint0_linear_2342_301)" stroke="#8B9E9D" strokeWidth="2" />
  <defs>
    <linearGradient id="paint0_linear_2342_301" x1="27.4277" y1="2.33594" x2="27.4277" y2="53.1913" gradientUnits="userSpaceOnUse">
      <stop stopColor="#0D2E18" />
      <stop offset="1" stopColor="#2D472E" />
    </linearGradient>
  </defs>
</svg>

const hotKeyChangeButtonIntersect = <svg className='intersect-svg' xmlns="http://www.w3.org/2000/svg" width="56" height="56" viewBox="0 0 56 56" fill="none">
  <path className='intersect-path' d="M2.38446 6.35269C1.63432 7.10284 1.21289 8.12025 1.21289 9.18112V46.0104C1.21289 47.0712 1.63432 48.0887 2.38446 48.8388L6.3974 52.8517C7.14755 53.6019 8.16496 54.0233 9.22583 54.0233H46.0554C47.1163 54.0233 48.1337 53.6019 48.8839 52.8517L52.8967 48.8389C53.6468 48.0888 54.0682 47.0714 54.0682 46.0105V9.18099C54.0682 8.12013 53.6468 7.10271 52.8967 6.35257L48.8836 2.33954C48.1335 1.5894 47.1161 1.16797 46.0552 1.16797H9.22604C8.16517 1.16797 7.14776 1.5894 6.39761 2.33954L2.38446 6.35269Z" fill="url(#paint0_linear_2348_20013)" stroke="#8B9E9D" strokeWidth="2" />
  <defs>
    <linearGradient id="paint0_linear_2348_20013" x1="27.6406" y1="2.16797" x2="27.6406" y2="53.0233" gradientUnits="userSpaceOnUse">
      <stop stopColor="#0F466D" />
      <stop offset="1" stopColor="#09253A" />
    </linearGradient>
  </defs>
</svg>

const hotKeyGrenadeButtonIntersect = <svg className='intersect-svg' xmlns="http://www.w3.org/2000/svg" width="56" height="56" viewBox="0 0 56 56" fill="none">
  <path className='intersect-path' d="M2.38446 6.35269C1.63432 7.10284 1.21289 8.12025 1.21289 9.18112V46.0104C1.21289 47.0712 1.63432 48.0887 2.38446 48.8388L6.3974 52.8517C7.14755 53.6019 8.16496 54.0233 9.22583 54.0233H46.0554C47.1163 54.0233 48.1337 53.6019 48.8839 52.8517L52.8967 48.8389C53.6468 48.0888 54.0682 47.0714 54.0682 46.0105V9.18099C54.0682 8.12013 53.6468 7.10271 52.8967 6.35257L48.8836 2.33954C48.1335 1.5894 47.1161 1.16797 46.0552 1.16797H9.22604C8.16517 1.16797 7.14776 1.5894 6.39761 2.33954L2.38446 6.35269Z" fill="url(#paint0_linear_2348_20090)" stroke="#8B9E9D" strokeWidth="2" />
  <defs>
    <linearGradient id="paint0_linear_2348_20090" x1="27.6406" y1="2.16797" x2="27.6406" y2="53.0233" gradientUnits="userSpaceOnUse">
      <stop stopColor="#5F2C16" />
      <stop offset="1" stopColor="#350D08" />
    </linearGradient>
  </defs>
</svg>

const hotKeyHealButtonVector = <svg className='vector-svg' xmlns="http://www.w3.org/2000/svg" width="39" height="41" viewBox="0 0 39 41" fill="none">
  <path className='vector-path' fillRule="evenodd" clipRule="evenodd" d="M13.4515 19.9105L11.1083 20.7041L0.620287 17.2762C0.598162 15.9494 0.450418 14.2879 0.558903 12.4743L10.967 9.38674L10.9385 4.82111C10.9385 4.82111 11.1212 4.26868 12.2196 3.42578C12.2196 3.42578 18.5888 0.964877 22.4893 0.649414C22.4893 0.649414 24.6904 1.5387 25.2364 2.15678C25.2364 2.15678 25.3934 4.35147 25.3563 5.17296C25.3563 5.17296 29.226 4.1488 30.7877 3.94539C30.7877 3.94539 37.0305 6.95012 37.7071 7.94005C37.8299 8.11919 37.7071 10.6329 37.7657 11.6821L35.511 12.4457L35.6288 14.2251L38.1404 13.3443C38.4194 19.6721 38.3352 28.7235 38.281 31.6283C38.281 31.6283 15.3014 40.407 12.8748 40.8781C12.8748 40.8781 2.34677 35.9963 1.64518 35.2397C1.64518 35.2397 0.720916 23.913 0.658823 19.4559L11.027 22.8567L13.5871 21.9575L13.4515 19.9105ZM32.9923 13.2979L16.25 18.9634L16.3834 20.9725L33.1122 15.1072L32.9923 13.2979ZM14.2202 8.56956L22.8818 5.8253C22.9325 5.20651 22.809 3.29161 22.809 3.29161C21.605 3.54498 14.3772 5.99301 14.3772 5.99301C14.3065 6.48119 14.2202 8.56956 14.2202 8.56956ZM23.5056 29.9582L23.5013 34.5117L27.8265 32.9273L27.8307 28.3738L31.5885 26.9963V22.6712L27.8307 24.0486L27.8343 19.7885L23.5092 21.3722L23.5056 25.6331L19.3489 27.2889V31.614L23.5056 29.9582Z" fill="url(#paint0_linear_2342_302)" />
  <defs>
    <linearGradient id="paint0_linear_2342_302" x1="19.4281" y1="0.649414" x2="19.4281" y2="40.8781" gradientUnits="userSpaceOnUse">
      <stop stopColor="#B4C4C3" />
      <stop offset="1" stopColor="#DFF0EF" />
    </linearGradient>
  </defs>
</svg>

const hotKeyChangeButtonVector = <svg className='vector-svg' xmlns="http://www.w3.org/2000/svg" width="40" height="44" viewBox="0 0 40 44" fill="none">
  <path className='vector-path' fillRule="evenodd" clipRule="evenodd" d="M0.476562 31.4255L3.54256 30.4268C4.97256 29.9234 6.13538 29.3126 6.13538 29.3126L6.2247 28.0662C4.78666 27.2574 3.83789 24.8695 3.64153 22.4537C3.62544 22.2481 3.64153 21.4426 3.64153 21.2371C3.64153 18.2244 5.75313 16.2551 8.3548 16.2551C10.9557 16.2551 13.0673 18.2244 13.0673 21.2371C13.0673 21.4426 13.0761 22.2481 13.0673 22.4537C12.9667 24.7664 11.9672 27.2079 10.4801 28.0498L10.5702 29.3126C10.5702 29.3126 11.5672 29.9811 13.163 30.4268L17.6606 31.8877C17.6606 31.8877 19.9911 33.2331 19.9251 35.3378L20.3902 43.6246H0.476562V31.4255ZM7.49535 35.3296V39.2666H6.35425V41.3383H10.9315V39.2666H10.0093V32.1766H8.05543L6.35425 33.8769V35.3296H7.49535ZM39.3792 15.4833V27.6866H19.4656L19.9307 19.3981C19.8647 17.2951 22.1952 15.9472 22.1952 15.9472L26.6928 14.4904C28.2886 14.0464 29.2856 13.3786 29.2856 13.3786L29.3757 12.1117C27.8886 11.2715 26.8892 8.82832 26.7886 6.51561C26.7797 6.31009 26.7886 5.50453 26.7886 5.29901C26.7886 2.28638 28.9002 0.317871 31.501 0.317871C34.1027 0.317871 36.2143 2.28638 36.2143 5.29901C36.2143 5.50453 36.2304 6.31092 36.2143 6.51561C36.0179 8.93149 35.0692 11.3193 33.6311 12.1274L33.7204 13.3786C33.7204 13.3786 34.8833 13.9886 36.3133 14.4904L39.3792 15.4833ZM31.7086 23.1858L34.6064 20.2813V17.8613L33.1467 16.3872H29.4804L28.0206 17.8613V19.6763H30.5345V18.7527L30.8307 18.4555H31.7964L32.0933 18.7527V19.347L28.0206 23.4276V25.562H34.6064V23.1858H31.7086ZM15.0718 9.03547C13.8181 9.00659 11.6485 9.30291 10.2322 11.0445C9.09836 12.4377 8.89718 13.8879 8.84729 13.9424C8.72014 14.0802 8.54149 14.1644 8.41434 14.3022C8.31616 14.1413 8.152 14.0266 8.05383 13.8656C8.00796 13.7897 8.04819 12.9519 8.05222 12.8727C8.31697 7.43676 13.0335 5.62671 15.0718 5.14964V2.06268L23.1174 7.27747L15.0718 12.493V9.03547ZM29.5745 36.4851C30.8283 36.5181 32.9978 36.221 34.4141 34.4794C35.548 33.0845 35.7492 31.6319 35.799 31.5823C35.9262 31.442 36.1048 31.3595 36.232 31.2192C36.3302 31.3843 36.4943 31.4998 36.5925 31.6567C36.6384 31.7309 36.5981 32.5728 36.5941 32.6471C36.3293 38.0864 31.6129 39.8939 29.5745 40.3726V43.4595L21.5289 38.2432L29.5745 33.0268V36.4851Z" fill="url(#paint0_linear_2348_20060)" />
  <defs>
    <linearGradient id="paint0_linear_2348_20060" x1="19.9279" y1="0.317871" x2="19.9279" y2="43.6246" gradientUnits="userSpaceOnUse">
      <stop stopColor="#B4C4C3" />
      <stop offset="1" stopColor="#DFF0EF" />
    </linearGradient>
  </defs>
</svg>

const hotKeyGrenadeButtonVector = <svg className='vector-svg' xmlns="http://www.w3.org/2000/svg" width="38" height="44" viewBox="0 0 38 44" fill="none">
  <path className='vector-path' fillRule="evenodd" clipRule="evenodd" d="M1.84798 16.4852C3.01723 15.3253 5.30942 15.0721 5.30942 15.0721C6.85453 16.1511 8.87351 19.5238 8.87351 19.5238C10.255 26.5246 14.1625 29.8433 14.1625 29.8433C15.8936 31.5644 17.8555 32.3361 19.4801 32.668C20.255 32.8223 20.9164 34.5511 21.2915 35.1145C21.9205 34.4662 22.8814 32.8146 22.8814 32.8146C26.8607 33.6173 31.9899 30.013 31.9899 30.013C30.8708 33.4012 27.5506 36.3802 27.5506 36.3802C27.2697 37.646 26.484 43.0253 26.484 43.0253H9.45466C10.2149 40.4861 11.8271 35.1145 11.8271 35.1145C8.98851 32.9381 5.92453 28.346 5.92453 28.346C5.40049 27.1883 4.42496 21.0449 4.42496 21.0449C3.63774 19.371 1.84798 16.4852 1.84798 16.4852ZM0.0751953 11.5358C0.0751953 11.5358 2.65681 2.92969 4.42496 0.970136C4.42496 0.970136 12.6722 1.64002 14.3092 2.14477L13.153 4.51414C13.153 4.51414 9.22313 4.96407 8.36259 5.20024L11.7083 6.73843L10.918 10.4561L17.4619 13.2222L19.4801 11.5358V13.2222L24.7167 15.032L25.5849 14.227L29.6661 17.2115H30.6463V18.7319L33.7959 21.5003H35.1079C35.1079 21.5003 35.1079 27.5202 28.7438 29.8433C28.7438 29.8433 21.0391 31.7033 15.8998 28.346C15.8998 28.346 10.918 25.4518 10.265 17.2115L8.36259 15.032L0.0751953 11.5358ZM5.92453 7.37823C5.09255 7.37823 4.41801 8.05275 4.41801 8.88396C4.41801 9.71594 5.09255 10.3905 5.92453 10.3905C6.75574 10.3905 7.43028 9.71594 7.43028 8.88396C7.43028 8.05275 6.75574 7.37823 5.92453 7.37823ZM15.8998 0.733948C19.7618 1.05501 20.8261 2.78381 20.8261 2.78381L18.0091 10.5256L13.7272 9.14714L15.8998 0.733948ZM22.9099 1.82369C26.7634 2.23351 27.7876 3.98703 27.7876 3.98703L24.7969 12.6256L20.3383 11.1661L22.9099 1.82369ZM29.2956 6.72685C33.0673 7.42145 33.4339 9.3594 33.4339 9.3594L30.5251 15.1717L26.4709 13.2222L29.2956 6.72685ZM34.5823 12.0143C36.7364 13.8427 37.7119 15.1138 37.7119 15.1138L34.5823 19.3702L32.0015 16.7399L34.5823 12.0143Z" fill="url(#paint0_linear_2348_20132)" />
  <defs>
    <linearGradient id="paint0_linear_2348_20132" x1="18.8936" y1="0.733948" x2="18.8936" y2="43.0253" gradientUnits="userSpaceOnUse">
      <stop stopColor="#B4C4C3" />
      <stop offset="1" stopColor="#DFF0EF" />
    </linearGradient>
  </defs>
</svg>

const hotKeyBlockVector = <svg className='block-vector-svg' xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 48 48" fill="none">
  <path d="M1.68359 46.9159L46.7864 1.81307" stroke="#B4B4B4" strokeWidth="3" />
</svg>

export class FigmaIngameRoot extends React.Component {
  constructor(props) {
    super(props);

    const rng = new Rng();

    const characters = new Array(2).fill(0).map((_, i) => {
      let name = rng.choice(names5);
      const role = rng.weighted_key(roles, "weight");
      return {
        ...createCharacter2({ rng, name, role }),
        idx: i,
        life: i,
      };
    });
    characters.push({
      ...createFixedCharacter2({ rng, key: 'Doomguy' }),
      life: 0,
      idx: 2,
    });
    characters.push({
      ...createFixedCharacter2({ rng, key: 'Indiana Jones' }),
      idx: 3,
    });

    const policies = [
      // i18n ignore 4
      { label: '교전 정책', value: '방어적' },
      { label: '이동 정책', value: '2' },
      { label: '도어 엔트리', value: '안함' },
      { label: '4번 용병 회복 정책', value: '호들갑' },
    ];

    const segments = [
      { total: 2, killed: 2, current: false },
      { total: 8, killed: 5, current: true },
      { total: 1, killed: 0, current: false },
      { total: 2, killed: 0, current: false },
      { total: 3, killed: 0, current: false },
      { total: 7, killed: 0, current: false },
    ];

    this.state = {
      rng,
      characters,
      policies,
      segments,
    };
  }

  render() {
    const { characters, policies, segments } = this.state;

    return <div className='figmaingame-testroot'>
      <FigmaIngameView
        characters={characters}
        policies={policies}
        segments={segments}
      />
      <FigmaIngameDialog
        name={characters[3].name}
        text={"hello world"}
      />
    </div>;
  }
}

export function FigmaIngameDialog(props) {
  const { name, text } = props;
  return <div className="figmaingame-dialog">
    <div className="figmaingame-dialog-bg" />
    <PortraitWrapper agent={{ name }} className="portrait-frame-small01" noframe={true} />
    <div className="figmaingame-dialog-name">{name}</div>
    <div className="figmaingame-dialog-text">{text}</div>
  </div>;
}

function RoleSpecificInfo(props) {
  const { entity } = props;
  const { role } = entity;
  const rolesDiscrete = ['pointman', 'breacher', 'medic'];
  const rolesContinuous = [];

  if (!rolesDiscrete.includes(role) && !rolesContinuous.includes(role)) {
    return <div className='figmaingame-agentcard-gauge'></div>;
  }

  let current = 0;
  let max = 0;
  switch (role) {
    case 'pointman':
      current = entity.throwables_cur;
      max = entity.throwables_max;
      break;
    case 'breacher':
      current = entity.attachables_cur;
      max = entity.attachables_max;
      break;
    case 'medic':
      current = entity.heals_cur;
      max = entity.heals_max;
      break;
    case 'vanguard':
      current = entity.shield;
      max = entity.shield_max;
      break;
  }

  return <div className='figmaingame-agentcard-gauge'>
    {max > 0 ? <>
      <div className='figmaingame-agentcard-gauge-icon'>{roleIcons[role]}</div>
      <div className='figmaingame-agentcard-gauge-value'>
        {rolesDiscrete.includes(role) ?
          <FigmaIngameProgressBarDiscrete current={current} max={max} subClass='gear' />
          :
          <FigmaIngameProgressBar current={current} max={max} subClass='gear' />}
        <span className='figmaingame-agentcard-gauge-value-desc'>{current}/{max}</span>
      </div>
    </>
      :
      null}
  </div>;
}

function FigmaIngameAgentCard(props) {
  // 사실은 extobj
  const { entity, idx, heal_ctrl, order_ctrl, len } = props;
  const { damage_max } = props;

  const { life, life_max } = entity;
  const { ammo, firearm_ammo_max } = entity;
  const { shield, shield_max } = entity;
  const { mood } = entity;
  const kills = entity.kills ?? 0;
  const damage = entity.damage ?? 100;

  const lifePercent = life / life_max || 0;
  const protectionPercent = (shield) / (shield_max) || 0;

  const isDead = life <= 0;

  const icons = [];
  // 임시로 구현, 이후 고도화
  if (mood !== null && mood !== undefined) {
    let src = null;
    if (mood >= 80) {
      src = '/img/ingame/mood_best.png';
    } else if (mood >= 60) {
      src = '/img/ingame/mood_good.png';
    } else if (mood < 21) {
      src = '/img/ingame/mood_worst.png';
    } else if (mood < 41) {
      src = '/img/ingame/mood_bad.png';
    }
    if (src) {
      icons.push(<div className='figmaingame-agentcard-icons-item'>
        <img key='mood' src={src} alt='mood' />
      </div>);
    }
  }

  const btn_heal = () => {
    if (heal_ctrl && heal_ctrl.btn_activate[idx]) {
      return <button onClick={() => { heal_ctrl.btn_heal_event(idx); }}>Heal</button>
    }
  };

  const btn_ordering = () => {
    if (!order_ctrl) {
      return;
    }
    const info = order_ctrl.btn_info[idx];
    if (info.activate) {
      const color_enable = '#000000';
      const color_disable = '#FFFFFF';
      return <span>
        {<button disabled={!info.up_activate}
          onClick={() => { order_ctrl.btn_order_event(idx, info.up_idx); }}
          style={{
            color: info.up_activate ? color_enable : color_disable,
          }}>▲</button>}
        {<button disabled={!info.down_activate}
          onClick={() => { order_ctrl.btn_order_event(idx, info.down_idx); }}
          style={{
            color: info.down_activate ? color_enable : color_disable,
          }}>▼</button>}
        {/* {info.up_activate ? <button onClick={() => { order_ctrl.btn_order_event(idx, info.up_idx); }}>▲</button> : []}
        {info.down_activate ? <button onClick={() => { order_ctrl.btn_order_event(idx, info.down_idx); }}>▼</button> : []} */}
      </span>;
    }
  };

  return <div className={'figmaingame-agentcard' + (isDead ? ' dead' : '')}>
    <div className='figmaingame-agentcard-detail'>
      <div className='figmaingame-agentcard-detail-card'>
        <RenderAgentSimple agent={entity} />
      </div>

      <div className='figmaingame-agentcard-gauges'>
        <div className='figmaingame-agentcard-gaugerow'>
          <div className='figmaingame-agentcard-gauge'>
            <div className='figmaingame-agentcard-gauge-icon'>{isDead ? svg_icon_skull : svg_icon_heart}</div>
            <div className='figmaingame-agentcard-gauge-value'>
              <FigmaIngameProgressBarDouble current={lifePercent} max={1} current2={protectionPercent} max2={1} subClass='life' subClass2='gear' />
            </div>
          </div>
        </div>
        <div className='figmaingame-agentcard-gaugerow'>
          <div className='figmaingame-agentcard-gauge'>
            <div className='figmaingame-agentcard-gauge-icon'>{svg_icon_bullets}</div>
            <div className='figmaingame-agentcard-gauge-value'>
              <FigmaIngameProgressBarDiscrete current={ammo} max={firearm_ammo_max} subClass='gear ammo' />
              <span className="figmaingame-agentcard-gauge-value-desc">{ammo}/{firearm_ammo_max}</span>
            </div>
          </div>
        </div>
        <div className='figmaingame-agentcard-gaugerow'>
          <RoleSpecificInfo entity={entity} />
        </div>
        <FigmaIngameCharacterBuffs buffs={entity.buffs} />
      </div>

      <div className='figmaingame-agentcard-gauges'>
        <div className='figmaingame-agentcard-gaugerow'>
          <div className='figmaingame-agentcard-gauge'>
            <div className='figmaingame-agentcard-gauge-label'>dmg</div>
            <div className='figmaingame-agentcard-gauge-value'>
              <FigmaIngameProgressBar current={damage} max={damage_max} label={damage > 0 ? damage.toFixed(0) : null} subClass='damage' />
            </div>
          </div>
        </div>
        <div className='figmaingame-agentcard-gaugerow'>
          <div className='figmaingame-agentcard-gauge'>
            <div className='figmaingame-agentcard-gauge-label'>kills</div>
            <div className='figmaingame-agentcard-gauge-value'>
              {kills}
            </div>
          </div>
        </div>
        <div className='figmaingame-agentcard-iconrow'>
          {icons}
        </div>
      </div>
    </div>
    {btn_ordering()}
    {btn_heal()}
  </div>;
}

function FigmaIngameThowableController(props) {
  const { throwable_ctrl, throwDisabled } = props;
  return <div className={`figmaingame-hotkey-button${(throwDisabled ? ' disabled' : '')}`} onClick={() => { throwDisabled ? null : throwable_ctrl.btn_throwable_event() }}>
    {hotKeyButtonUnion}
    {hotKeyGrenadeButtonIntersect}
    {hotKeyGrenadeButtonVector}
    {throwDisabled ? hotKeyBlockVector : <></>}
    <div className='initial'>I</div>
  </div>;
}

function FigmaIngameOrderController(props) {
  const { order_ctrl, orderDisabled } = props;
  return <div className={`figmaingame-hotkey-button${(orderDisabled ? ' disabled' : '')}`} onClick={() => { orderDisabled ? null : order_ctrl.order_btn_activate(); }}>
    {hotKeyButtonUnion}
    {hotKeyChangeButtonIntersect}
    {hotKeyChangeButtonVector}
    {orderDisabled ? hotKeyBlockVector : <></>}
    <div className='initial'>P</div>
  </div >;
}

function FigmaIngameHealController(props) {
  const { heal_ctrl, healDisabled } = props;
  return <div className={`figmaingame-hotkey-button${(healDisabled ? ' disabled' : '')}`} onClick={() => { healDisabled ? null : heal_ctrl.heal_btn_activate(); }}>
    {hotKeyButtonUnion}
    {hotKeyHealButtonIntersect}
    {hotKeyHealButtonVector}
    {healDisabled ? hotKeyBlockVector : <></>}
    <div className='initial'>O</div>
  </div>;
}

export function FigmaIngameAgentList(props) {
  const { entities, throwable_controller, heal_ctrl, order_ctrl } = props;
  const canHeal = heal_ctrl && heal_ctrl.can_heal;
  const canOrder = order_ctrl && order_ctrl.can_order;
  const canThrow = throwable_controller && throwable_controller.can_throw;

  const initialCanHeal = useRef(null);
  const initialCanOrder = useRef(null);
  const initialCanThrow = useRef(null);

  useEffect(() => {
    if (initialCanHeal.current === null) {
      initialCanHeal.current = heal_ctrl && heal_ctrl.can_heal;
    }
    if (initialCanOrder.current === null) {
      initialCanOrder.current = order_ctrl && order_ctrl.can_order;
    }
    if (initialCanThrow.current === null) {
      initialCanThrow.current = throwable_controller && throwable_controller.can_throw;
    }
  }, [heal_ctrl, order_ctrl, throwable_controller]);

  const can_heal = initialCanHeal.current;
  const can_order = initialCanOrder.current;
  const can_throw = initialCanThrow.current;

  const props0 = {
    kills_max: _.max(entities.map((e) => e.kills ?? 0)),
    damage_max: _.max(entities.map((e) => e.damage ?? 100)),
  };

  return <div className='figmaingame-agentlist'>
    <div className='figmaingame-hotkey-group'>
      {can_heal ? <FigmaIngameHealController heal_ctrl={heal_ctrl} healDisabled={!canHeal} /> : []}
      {can_order ? <FigmaIngameOrderController order_ctrl={order_ctrl} orderDisabled={!canOrder} /> : []}
      {can_throw ? <FigmaIngameThowableController throwable_ctrl={throwable_controller} throwDisabled={!canThrow} /> : []}
    </div>
    {entities.map((entity, i) => <FigmaIngameAgentCard
      key={i}
      entity={entity}
      {...props0}
      idx={i}
      heal_ctrl={heal_ctrl}
      order_ctrl={order_ctrl}
      len={entities.length} />)}
  </div>;
}

const svg_icon_heart = <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
  <path d="M10.5 6.4949C10.5 5.53459 9.04492 4 7.25 4C5.45508 4 4 5.66428 4 7.53182C4 8.40493 4.31803 9.20074 4.84015 9.80071L10.5 17L16.16 9.80059C16.682 9.20064 17 8.40487 17 7.53182C17 5.66428 15.5449 4 13.75 4C11.9551 4 10.5 5.573 10.5 6.4949Z" fill="#59AF5C" />
</svg>

const svg_icon_bullets = <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
  <path d="M5 6.94643C5 5.76786 5.61303 4.29464 6.53258 4C7.45213 4.29464 8.06517 5.76786 8.06517 6.94643V15.7857H5V6.94643Z" fill="#D3C6B2" />
  <path d="M8.98313 6.94643C8.98313 5.76786 9.59616 4.29464 10.5157 4C11.4353 4.29464 12.0483 5.76786 12.0483 6.94643V15.7857H8.98313V6.94643Z" fill="#D3C6B2" />
  <path d="M14.4674 4C13.5479 4.29464 12.9348 5.76786 12.9348 6.94643V15.7857H16V6.94643C16 5.76786 15.387 4.29464 14.4674 4Z" fill="#D3C6B2" />
</svg>

const svg_icon_vest = <svg xmlns="http://www.w3.org/2000/svg" width="21" height="20" viewBox="0 0 21 20" fill="none">
  <path d="M4.6665 5.99884L5.85656 5.08016L5.88873 3H7.99545L8.30101 5.99884H12.032L12.3376 3H14.4443L14.4764 5.08016L15.6665 5.99884V15.1576C13.9554 16.1172 11.2869 16.3571 10.1665 16.3571C9.04613 16.3571 6.37761 16.1172 4.6665 15.1576V5.99884Z" fill="#D3C6B2" />
</svg>

const svg_icon_grenade = <svg xmlns="http://www.w3.org/2000/svg" width="21" height="20" viewBox="0 0 21 20" fill="none">
  <path d="M7.95674 3L8.09234 5.7475C6.03962 6.49196 4.53418 8.36341 4.33751 10.6066H15.7979C15.6059 8.41612 14.1659 6.58012 12.1869 5.80184V4.80163H14.2057C14.915 5.68745 15.9552 7.21451 16.4302 9.35942L17.3335 9.30571C17.3335 6.60326 15.8496 3.73508 15.2143 3H7.95674Z" fill="#D3C6B2" />
  <path d="M4.3335 11.5599H15.802C15.5694 14.4992 13.0909 16.8125 10.0677 16.8125C7.04454 16.8125 4.56608 14.4992 4.3335 11.5599Z" fill="#D3C6B2" />
</svg>

const svg_icon_skull = <svg xmlns="http://www.w3.org/2000/svg" width="22" height="24" viewBox="0 0 22 24" fill="none">
  <path fillRule="evenodd" clipRule="evenodd" d="M4.16623 19.4689C2.65437 19.4689 2.66524 19.0967 2.70965 17.5747C2.71841 17.2752 2.72843 16.931 2.72843 16.5366C2.72843 15.5875 2.44506 15.1387 2.10282 14.5967C1.57989 13.7686 0.91904 12.7222 0.919022 9.33887C0.918965 -2.04775 21.081 -2.04775 21.081 9.33887C21.081 12.7222 20.4199 13.7689 19.897 14.597C19.5548 15.139 19.2716 15.5875 19.2716 16.5366C19.2716 16.931 19.2816 17.2751 19.2903 17.5746C19.3348 19.0966 19.3456 19.4689 17.8338 19.4689C16.0244 19.4689 16.0244 21.0685 16.0244 22.1347C16.0244 23.2011 13.5848 23.2011 11 23.2011C8.41517 23.2011 5.97564 23.2011 5.97564 22.1347C5.97564 21.0685 5.97564 19.4689 4.16623 19.4689ZM6.9046 17.6005C8.47049 17.6005 9.73988 16.2075 9.73988 14.4891C9.73988 12.7708 8.47049 11.3777 6.9046 11.3777C5.33871 11.3777 4.06933 12.7708 4.06933 14.4891C4.06933 16.2075 5.33871 17.6005 6.9046 17.6005ZM12.8902 19.6391C12.8902 20.1958 12.4663 20.712 11.886 20.712C11.4833 20.712 11.1845 20.4803 11 20.1518C10.8156 20.4803 10.5167 20.712 10.114 20.712C9.5336 20.712 9.10982 20.1956 9.10982 19.6391C9.10982 18.4475 11 17.6005 11 17.6005C11 17.6005 12.8902 18.3963 12.8902 19.6391ZM15.0954 17.6005C16.6613 17.6005 17.9307 16.2075 17.9307 14.4891C17.9307 12.7708 16.6613 11.3777 15.0954 11.3777C13.5295 11.3777 12.2601 12.7708 12.2601 14.4891C12.2601 16.2075 13.5295 17.6005 15.0954 17.6005Z" fill="white" />
</svg>

function FigmaIngameProgressBar(props) {
  const { current, limit, max, subClass } = props;
  let fg = 100 * current / max;
  let bg = 100 - (100 * current / max);

  let elem_limit = null;
  if (limit) {
    const width_l = 100 * ((limit - current)) / max;
    bg = 100 - fg - width_l;
    elem_limit = <div className={'figmaingame-progressbar-limit ' + subClass ?? 'default'} style={{ width: `${width_l}%` }}></div>
  }

  let label = props.label;
  if (label) {
    label = <span className='figmaingame-progressbar-container-label'><span>{label}</span></span>;
  }

  return <div className='figmaingame-progressbar-container stock'>
    <div className={'figmaingame-progressbar-fg ' + subClass ?? 'default'} style={{ width: `${fg}%` }}></div>
    {elem_limit}
    <div className={'figmaingame-progressbar-bg ' + subClass ?? 'default'} style={{ width: `${bg}%` }}></div>
    {label}
  </div>;
}

function FigmaIngameProgressBarDouble(props) {
  const { current, limit, max, subClass, current2, max2, subClass2 } = props;
  let fg = 100 * current / max;
  let fg2 = 100 * current2 / max2;
  let bg = 100 - Math.max(fg, fg2);

  let elem_limit = null;
  if (limit) {
    const width_l = 100 * ((limit - current)) / max;
    bg = bg - width_l;
    elem_limit = <div className={'figmaingame-progressbar-limit ' + subClass ?? 'default'} style={{ width: `${width_l}%` }}></div>
  }

  return <div className='figmaingame-progressbar-container'>
    <div className={'figmaingame-progressbar-fg ' + subClass2 ?? 'default'} style={{ width: `${fg2}%` }}></div>
    {fg > fg2 ? <div className={'figmaingame-progressbar-fg ' + subClass ?? 'default'} style={{ width: `${fg - fg2}%` }}></div> : null}
    {elem_limit}
    <div className={'figmaingame-progressbar-bg ' + subClass ?? 'default'} style={{ width: `${bg}%` }}></div>
  </div>;
}

function FigmaIngameProgressBarDiscrete(props) {
  const { current, max, subClass } = props;
  const fgs = new Array(current >= 0 ? current : 0).fill(0);
  const bgs = max > current ? new Array(current >= 0 ? max - current : max).fill(0) : [];
  return <div className={'figmaingame-progressbar-container discrete ' + subClass}>
    {fgs.map((_, i) => <div key={'fg' + i} className={'figmaingame-progressbar-fg discrete ' + subClass ?? 'default'}></div>)}
    {bgs.map((_, i) => <div key={'bg' + i} className={'figmaingame-progressbar-bg discrete ' + subClass ?? 'default'}></div>)}
  </div>;
}

function FigmaIngamePolicyCard(props) {
  const { policies } = props;
  return <div className='figmaingame-policycard'>
    {policies.map((policy, i) => <div key={i} className='figmaingame-policycard-item'>
      <div className='figmaingame-policycard-label'>{policy.label}</div>
      <div className='figmaingame-policycard-value'>{policy.value}</div>
    </div>)}
  </div>;
}

export const svg_icon_target = <svg xmlns="http://www.w3.org/2000/svg" width="16" height="27" viewBox="0 0 16 27" fill="none">
  <path d="M10.0174 11.3663C11.7224 10.5983 12.9091 8.88688 12.9091 6.89886C12.9091 4.19329 10.7112 2 8 2C5.28878 2 3.09091 4.19329 3.09091 6.89886C3.09091 8.88688 4.27757 10.5983 5.9826 11.3663L2.64877 13.6103C2.23365 14.0194 2 14.5773 2 15.1595V21.8227C2 23.0252 2.97683 24 4.18182 24H11.8182C13.0232 24 14 23.0252 14 21.8227V15.1595C14 14.5773 13.7663 14.0194 13.3512 13.6103L10.0174 11.3663Z" fill="#DA2700" />
</svg>

export const svg_icon_new_target = <svg xmlns="http://www.w3.org/2000/svg" width="16" height="27" viewBox="0 0 16 27" fill="none">
  <path d="M10.0174 11.3663C11.7224 10.5983 12.9091 8.88688 12.9091 6.89886C12.9091 4.19329 10.7112 2 8 2C5.28878 2 3.09091 4.19329 3.09091 6.89886C3.09091 8.88688 4.27757 10.5983 5.9826 11.3663L2.64877 13.6103C2.23365 14.0194 2 14.5773 2 15.1595V21.8227C2 23.0252 2.97683 24 4.18182 24H11.8182C13.0232 24 14 23.0252 14 21.8227V15.1595C14 14.5773 13.7663 14.0194 13.3512 13.6103L10.0174 11.3663Z" fill="#FF00FF" />
</svg>

export const svg_icon_updated_target = <svg xmlns="http://www.w3.org/2000/svg" width="16" height="27" viewBox="0 0 16 27" fill="none">
  <path d="M10.0174 11.3663C11.7224 10.5983 12.9091 8.88688 12.9091 6.89886C12.9091 4.19329 10.7112 2 8 2C5.28878 2 3.09091 4.19329 3.09091 6.89886C3.09091 8.88688 4.27757 10.5983 5.9826 11.3663L2.64877 13.6103C2.23365 14.0194 2 14.5773 2 15.1595V21.8227C2 23.0252 2.97683 24 4.18182 24H11.8182C13.0232 24 14 23.0252 14 21.8227V15.1595C14 14.5773 13.7663 14.0194 13.3512 13.6103L10.0174 11.3663Z" fill="#FFFF00" />
</svg>


export const svg_icon_neutralized = <svg xmlns="http://www.w3.org/2000/svg" width="16" height="27" viewBox="0 0 16 27" fill="none">
  <path d="M10.0174 11.3663C11.7224 10.5983 12.9091 8.88688 12.9091 6.89886C12.9091 4.19329 10.7112 2 8 2C5.28878 2 3.09091 4.19329 3.09091 6.89886C3.09091 8.88688 4.27757 10.5983 5.9826 11.3663L2.64877 13.6103C2.23365 14.0194 2 14.5773 2 15.1595V21.8227C2 23.0252 2.97683 24 4.18182 24H11.8182C13.0232 24 14 23.0252 14 21.8227V15.1595C14 14.5773 13.7663 14.0194 13.3512 13.6103L10.0174 11.3663Z" fill="#948C8C" />
  <path d="M2 23.1273L12 3.12735" stroke="#D6D6D6" strokeWidth="2.5" strokeLinecap="square" />
</svg>

export function FigmaIngameProgressBoard(props) {
  const { segments } = props;
  return <div className='figmaingame-progressboard'>
    {segments.map((segment, i) => {
      const { total, killed, current } = segment;

      return <div key={i} className={'figmaingame-progressboard-segment' + (current ? ' current' : '')}>
        <div className='figmaingame-progressboard-segment-label'>{'#' + (i + 1).toString().padStart(2, "0")}</div>
        <div className='figmaingame-progressboard-segment-tallymarks'>
          <FigmaIngameProgressTallyMarks total={total} neutralized={killed} />
        </div>
      </div>;
    })}
  </div>
}

function FigmaIngameProgressTallyMarks(props) {
  const { total, neutralized } = props;
  return new Array(total).fill(0).map((_, i) => {
    if (i < neutralized) {
      return <div key={i} className='figmaingame-tallymark-neutralized'>{svg_icon_neutralized}</div>;
    }
    return <div key={i} className='figmaingame-tallymark-target'>{svg_icon_target}</div>;
  });
}

function polarToCartesian(centerX, centerY, radius, angleInDegrees) {
  var angleInRadians = angleInDegrees * Math.PI / 180.0;

  return {
    x: centerX + (radius * Math.cos(angleInRadians)),
    y: centerY + (radius * Math.sin(angleInRadians))
  };
}

function describeArcWithStroke(x, y, radius, startAngle, endAngle, strokeWidth) {
  const radiusOut = radius + strokeWidth / 2;
  const radiusIn = radius - strokeWidth / 2;
  const startOut = polarToCartesian(x, y, radiusOut, startAngle);
  const startIn = polarToCartesian(x, y, radiusIn, startAngle);
  const endOut = polarToCartesian(x, y, radiusOut, endAngle);
  const endIn = polarToCartesian(x, y, radiusIn, endAngle);

  const largeArcFlag = (startAngle - endAngle <= 180 && startAngle - endAngle >= 0) ? "0" : "1";

  const d = [
    "M", startOut.x, startOut.y,
    "A", radiusOut, radiusOut, 0, largeArcFlag, 0, endOut.x, endOut.y,
    "L", endIn.x, endIn.y,
    "A", radiusIn, radiusIn, 0, largeArcFlag, 1, startIn.x, startIn.y,
    "Z"
  ].join(" ");

  return d;
}

function SvgIconAmmo(props) {
  const { state, percent } = props;
  const startAngle = 270;
  const endAngle = (startAngle - 360 * percent) % 360;

  let color = null;
  if (state === 'reload') {
    color = '#D3C6B2';
  } else if (percent > 0.9) {
    color = '#03BD59';
  } else {
    color = '#E5A72D';
  }

  let newPath = null;
  if (percent > 0 && percent < 1) {
    newPath = <path d={describeArcWithStroke(14.5, 13.5, 11, startAngle, endAngle, 3)} fill={color} />;
  } else if (percent >= 1) {
    newPath = <circle cx="14.5" cy="13.5" r="11" stroke={color} strokeWidth="3" />;
  }

  if (state === 'reload') {
    return <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 28 28" fill="none">
      <path fillRule="evenodd" clipRule="evenodd" d="M15.5 7.58304V4.95969L8.57457 10.5H14.9629C16.2531 10.7003 17.2823 11.7623 17.4695 13.0708L17.5309 13.5H20.5245L20.4754 12.9551C20.2298 10.2293 18.1626 8.02991 15.5 7.58304Z" fill={color} />
      <path fillRule="evenodd" clipRule="evenodd" d="M13.5 19.417V22.0403L20.4254 16.5H14.4999C12.989 16.5 11.7382 15.3826 11.5303 13.9292L11.4689 13.5H8.47522L8.52432 14.0449C8.76996 16.7707 10.8373 18.9702 13.5 19.417Z" fill={color} />
      <circle cx="14.5" cy="13.5" r="11" stroke="black" strokeWidth="3" />
      {newPath}
    </svg>;
  }

  return <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 28 28" fill="none">
    <path d="M9 10.9792C9 9.7875 9.61303 8.29792 10.5326 8C11.4521 8.29792 12.0652 9.7875 12.0652 10.9792V19H9V10.9792Z" fill={color} />
    <path d="M12.9831 10.9792C12.9831 9.7875 13.5962 8.29792 14.5157 8C15.4353 8.29792 16.0483 9.7875 16.0483 10.9792V19H12.9831V10.9792Z" fill={color} />
    <path d="M18.4674 8C17.5479 8.29792 16.9348 9.7875 16.9348 10.9792V19H20V10.9792C20 9.7875 19.387 8.29792 18.4674 8Z" fill={color} />
    <circle cx="14.5" cy="13.5" r="11" stroke="black" strokeWidth="3" />
    {newPath}
  </svg>;
}

const svg_icon_state_shoot = <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 28 28" fill="none">
  <path fillRule="evenodd" clipRule="evenodd" d="M2 21.0832L5.2047 12.0424V10.6672C6.82174 10.333 8.05723 9.29202 8.05723 7H26L25.1724 12.9593H16.4726L15.0463 17.0849H11.061L9.95891 22L2 21.0832ZM11.3286 15.2513H13.6756L14.468 12.9593H11.7373L11.3286 15.2513Z" fill="#D3C6B2" />
</svg>;

const svg_icon_state_walk = <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 28 28" fill="none">
  <path d="M15.4362 14.0845C14.2362 9.28449 15.7696 7.58449 16.9363 7.08449C19.4363 6.58449 21.4362 8.41781 21.9363 9.58447C23.4362 12.0844 22.6029 15.7512 22.4362 17.0845L21.4363 23.0845C20.6363 25.4845 18.9363 25.2512 18.4363 25.0845C17.2363 25.0845 15.9362 24.0845 15.9362 22.5845C15.9818 20.818 16.4363 19.0846 16.4363 18.0845C16.4363 17.0845 15.4362 14.0845 15.4362 14.0845Z" fill="#D3C6B2" />
  <path d="M12.3809 10.0845C13.5809 5.28449 12.0475 3.58449 10.8809 3.08449C8.38086 2.58449 6.38092 4.41781 5.88086 5.58447C4.38094 8.08442 5.21426 11.7512 5.38093 13.0845L6.38086 19.0845C7.18086 21.4845 8.88085 21.2512 9.38085 21.0845C10.5808 21.0845 11.8809 20.0845 11.8809 18.5845C11.8353 16.818 11.3808 15.0846 11.3808 14.0845C11.3809 13.0845 12.3809 10.0845 12.3809 10.0845Z" fill="#D3C6B2" />
</svg>

function SvgIconState(props) {
  const { state } = props;
  return state === 'aim' ? svg_icon_state_shoot : svg_icon_state_walk;
}

function SvgIconVest(fill) {
  return <svg xmlns="http://www.w3.org/2000/svg" width="17" height="18" viewBox="0 0 17 18" fill="none">
    <path d="M3 5.49884L4.19006 4.58016L4.22222 2.5H6.32895L6.6345 5.49884H10.3655L10.6711 2.5H12.7778L12.8099 4.58016L14 5.49884V14.6576C12.2889 15.6172 9.62037 15.8571 8.5 15.8571C7.37963 15.8571 4.71111 15.6172 3 14.6576V5.49884Z" fill={fill} />
  </svg>;
}

function SvgIconShield(fill) {
  return <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
    <path d="M3.5 2.49884H14.5V7.65761C14.5 10.5001 12 14.5001 9 15.8571C6 14.5001 3.5 10.5001 3.5 7.65761V2.49884Z" fill={fill} />
  </svg>;
}

const svg_icon_state_stun = <svg xmlns="http://www.w3.org/2000/svg" width="56" height="56" viewBox="0 0 56 56" fill="none">
  <g filter="url(#filter0_f_109_713)">
    <path fillRule="evenodd" clipRule="evenodd" d="M29.6316 42.6674C30.538 42.6536 31.285 43.378 31.2988 44.2844C31.3127 45.1908 30.5882 45.9377 29.6818 45.9516C25.5062 45.7357 21.7237 44.2166 18.7686 41.6953C15.8775 39.2287 13.7785 35.8933 12.9595 32.0745C12.9357 31.9909 12.9841 31.9037 13.0677 31.8797C13.1513 31.8559 13.2386 31.9043 13.2624 31.9879C14.5044 35.4424 16.8402 38.3162 19.8425 40.251C22.6533 42.0622 26.0449 42.963 29.6316 42.6674ZM43.8072 19.6929C43.3249 18.9253 43.5564 17.9108 44.3239 17.4285C45.0913 16.9463 46.1061 17.1777 46.5883 17.9453C48.5713 21.6264 49.2361 25.6479 48.615 29.4826C48.0073 33.2339 46.2461 36.7595 43.4069 39.4416C43.3479 39.5054 43.2483 39.5091 43.1845 39.4501C43.1206 39.3911 43.1168 39.2915 43.1758 39.2275C45.4839 36.3731 46.7276 32.8849 46.8229 29.3143C46.9123 25.9717 45.9217 22.6053 43.8072 19.6929ZM17.2475 19.31C16.8593 20.1292 15.8792 20.4791 15.0601 20.0912C14.2409 19.7032 13.8909 18.7231 14.2789 17.9039C16.3174 14.2535 19.3515 11.5313 22.9193 9.99421C26.4093 8.49046 30.3288 8.08104 34.1166 9.03357C34.2021 9.04905 34.259 9.1311 34.2435 9.21672C34.2278 9.30233 34.1458 9.35908 34.0604 9.34359C30.4127 8.9315 26.8025 9.75714 23.7404 11.5957C20.8737 13.317 18.5671 15.9617 17.2475 19.31ZM29.1182 40.5377L33.8019 40.0657L35.534 34.9646L37.2373 39.9865L41.1705 40.2022L38.3741 43.2293L40.1921 48.5823L35.6412 45.3126L31.8161 47.4366L32.8155 43.3573L29.1182 40.5377ZM42.2536 21.2373L39.4186 17.4789L34.1598 18.6463L37.5679 14.5837L35.7106 11.1099L39.7496 11.9288L43.3813 7.59634L42.9487 13.1833L46.7497 15.3501L42.7442 16.6134L42.2536 21.2373ZM19.3848 19.79L17.7389 24.2006L21.5499 28.0081L16.2921 27.3174L14.3608 30.7506L12.8807 26.9044L7.2754 26.1703L12.2192 23.5323L12.0038 19.1625L15.2218 21.8614L19.3848 19.79ZM30.4163 34.62C29.4493 34.62 28.6644 33.8352 28.6643 32.8682C28.6643 31.9014 29.4494 31.1164 30.4162 31.1164C31.8275 31.187 33.1462 30.7252 34.1182 29.8457C35.1403 28.9208 35.8426 27.6277 35.9168 26.1436C35.9946 24.587 35.4616 23.1406 34.4915 22.0685C33.476 20.946 32.0457 20.1966 30.4161 20.115C28.7138 20.0301 27.1399 20.6344 25.9676 21.6951C24.745 22.8014 23.9483 24.3686 23.8596 26.1437C23.8598 26.2364 23.7843 26.3117 23.6916 26.3117C23.5988 26.3116 23.5236 26.2364 23.5236 26.1437C23.4266 24.2033 24.1475 22.4207 25.3567 21.0842C26.6113 19.6976 28.403 18.8238 30.4161 18.7232C32.5021 18.619 34.4122 19.4111 35.8489 20.7109C37.3359 22.0561 38.2566 23.9849 38.3645 26.1437C38.476 28.3754 37.6129 30.4129 36.2224 31.9498C34.7862 33.5369 32.7206 34.5049 30.4163 34.62ZM28.1431 34.7494L25.178 33.0619L22.0134 35.3481L23.1154 31.6664L20.8827 29.8879L23.8054 29.2736L24.9786 25.3481L26.2943 29.1901L29.4456 29.5414L27.1427 31.5315L28.1431 34.7494Z" fill="#FF2E00" />
  </g>
  <path fillRule="evenodd" clipRule="evenodd" d="M29.6316 42.6674C30.538 42.6536 31.285 43.378 31.2988 44.2844C31.3127 45.1908 30.5882 45.9377 29.6818 45.9516C25.5062 45.7357 21.7237 44.2166 18.7686 41.6953C15.8775 39.2287 13.7785 35.8933 12.9595 32.0744C12.9357 31.9909 12.9841 31.9037 13.0677 31.8797C13.1513 31.8559 13.2386 31.9043 13.2624 31.9879C14.5044 35.4424 16.8402 38.3162 19.8425 40.251C22.6533 42.0622 26.0449 42.963 29.6316 42.6674ZM43.8072 19.6929C43.3249 18.9253 43.5563 17.9108 44.3239 17.4285C45.0913 16.9463 46.1061 17.1777 46.5883 17.9453C48.5712 21.6264 49.2361 25.6479 48.6149 29.4826C48.0073 33.2338 46.2461 36.7594 43.4069 39.4416C43.3479 39.5054 43.2483 39.5091 43.1845 39.4501C43.1205 39.3911 43.1168 39.2915 43.1758 39.2275C45.4839 36.3731 46.7276 32.8849 46.8229 29.3143C46.9123 25.9717 45.9216 22.6052 43.8072 19.6929ZM17.2475 19.31C16.8593 20.1292 15.8792 20.4791 15.06 20.0911C14.2409 19.7032 13.8909 18.7231 14.2789 17.9039C16.3174 14.2535 19.3515 11.5313 22.9192 9.99421C26.4093 8.49045 30.3288 8.08103 34.1166 9.03356C34.202 9.04904 34.259 9.13109 34.2435 9.21671C34.2278 9.30233 34.1458 9.35907 34.0603 9.34359C30.4126 8.9315 26.8025 9.75713 23.7404 11.5957C20.8736 13.317 18.5671 15.9617 17.2475 19.31ZM29.1181 40.5377L33.8018 40.0657L35.534 34.9646L37.2373 39.9865L41.1705 40.2022L38.374 43.2293L40.1921 48.5822L35.6412 45.3126L31.8161 47.4365L32.8155 43.3573L29.1181 40.5377ZM42.2536 21.2373L39.4186 17.4789L34.1597 18.6463L37.5679 14.5837L35.7106 11.1099L39.7496 11.9288L43.3813 7.59633L42.9487 13.1833L46.7497 15.3501L42.7441 16.6134L42.2536 21.2373ZM19.3848 19.79L17.7389 24.2006L21.5499 28.0081L16.2921 27.3174L14.3608 30.7506L12.8807 26.9044L7.27539 26.1703L12.2192 23.5323L12.0037 19.1625L15.2218 21.8614L19.3848 19.79ZM30.4163 34.62C29.4493 34.62 28.6643 33.8352 28.6643 32.8682C28.6643 31.9013 29.4494 31.1164 30.4162 31.1164C31.8275 31.187 33.1462 30.7252 34.1182 29.8457C35.1403 28.9208 35.8426 27.6277 35.9168 26.1436C35.9946 24.587 35.4616 23.1406 34.4915 22.0685C33.476 20.946 32.0457 20.1966 30.4161 20.115C28.7138 20.0301 27.1399 20.6344 25.9676 21.6951C24.745 22.8014 23.9483 24.3686 23.8596 26.1436C23.8597 26.2364 23.7843 26.3117 23.6916 26.3116C23.5988 26.3116 23.5236 26.2364 23.5236 26.1437C23.4266 24.2033 24.1474 22.4207 25.3567 21.0842C26.6113 19.6976 28.403 18.8238 30.4161 18.7232C32.5021 18.619 34.4122 19.4111 35.8489 20.7109C37.3359 22.0561 38.2566 23.9849 38.3645 26.1437C38.476 28.3753 37.6128 30.4129 36.2224 31.9498C34.7862 33.5369 32.7206 34.5049 30.4163 34.62ZM28.1431 34.7493L25.178 33.0619L22.0134 35.3481L23.1154 31.6663L20.8827 29.8879L23.8054 29.2736L24.9786 25.3481L26.2943 29.1901L29.4455 29.5414L27.1427 31.5315L28.1431 34.7493Z" fill="#FFDF35" />
  <defs>
    <filter id="filter0_f_109_713" x="0.275406" y="0.596336" width="55.5641" height="54.9859" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
      <feFlood floodOpacity="0" result="BackgroundImageFix" />
      <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
      <feGaussianBlur stdDeviation="3.5" result="effect1_foregroundBlur_109_713" />
    </filter>
  </defs>
</svg>

export function FigmaIngameCharacterHudLine(props) {
  const { pos, anchor, isAlly, isIdle } = props;

  const size = [
    [154, 80],
    [121, 49],
  ][isAlly ? 0 : 1];

  const linepos = [
    [-1, -1],
    [1, -1],
    [1, 1],
    [-1, 1],
  ].map(([x, y]) => pos.add(new v2(size[0] / 2 * x, size[1] / 2 * y)))
    .sort((a, b) => a.sub(anchor).len() - b.sub(anchor).len())[0];

  const len = linepos.sub(anchor).len();
  let angle = linepos.sub(anchor).dir();
  if (isNaN(angle)) {
    angle = 0;
  }
  angle += Math.PI / 2;

  let cls = 'figmaingame-characterhud-line ';
  cls += isAlly ? 'ally' : 'enemy';
  cls += isIdle ? ' idle' : '';

  return <div className={cls}
    style={{
      left: `${linepos.x}px`,
      top: `${linepos.y}px`,
      width: `${len}px`,
      transform: `rotate(${angle * 180 / Math.PI}deg)`,
    }}
  />;
}

export function FigmaIngameAimLine(props) {
  const { from, to } = props;

  const diff = from.sub(to);
  const len = diff.len();
  let angle = diff.dir();
  if (isNaN(angle)) {
    angle = 0;
  }
  angle += Math.PI / 2;

  let cls = 'figmaingame-characterhud-line connecting-line ';

  return <div className={cls}
    style={{
      left: `${from.x}px`,
      top: `${from.y}px`,
      width: `${len}px`,
      transform: `rotate(${angle * 180 / Math.PI}deg)`,
    }}
  />;

}

const lerp = function (a, b, t) {
  return a + (b - a) * t;
}

export class FigmaIngameCharacterHud extends React.Component {
  constructor(props) {
    super(props);
    const value = 0 | (props.lifePercent * 100);
    this.state = {
      anim: false,
      acc: 0,
      value,
      limit: value,

      lifePercent: props.lifePercent,
    };

    this.tick = this.onTick.bind(this);
  }

  componentDidMount() {
    this.timer = requestAnimationFrame(this.tick);
  }

  componentWillUnmount() {
    cancelAnimationFrame(this.timer);
  }

  onTick() {
    let { anim, acc, value, limit } = this.state;
    const propvalue = 0 | (this.props.lifePercent * 100);
    acc += 1;
    if (value !== propvalue) {
      acc = 0;
      value = propvalue;
    } else {
      acc += 1;
    }
    if (acc > 60) {
      anim = true;
    }

    if (anim) {
      limit = Math.floor(lerp(limit, propvalue, 0.05));
      if (limit === propvalue) {
        anim = false;
      }
    }

    this.setState({ anim, acc, value, limit });

    this.timer = requestAnimationFrame(this.tick);
  }

  render() {
    const { value, limit } = this.state;
    const props = {
      ...this.props,
      lifePercent: value / 100,
      lifeLimit: limit / 100,
    };
    return <FigmaIngameCharacterHud0 {...props} />;
  }
}

export function FigmaIngameCharacterHud0(props) {
  const { isAlly, name, enemyId, lifePercent, shieldPercent, state, ammoPercent, pos, onClick, compact, buffs } = props;
  const { isIdle, passiveState, shieldReason } = props;
  const lifeLimit = props.lifeLimit;

  const isDeadAlly = isAlly && lifePercent <= 0;

  const passiveLabel = ((passiveState) => {
    switch (passiveState) {
      case 'covered':
        return L('loc_ui_string_ingame_agent_hud_covered');
      case 'obstructed':
        return L('loc_ui_string_ingame_agent_hud_obstructed');
      case 'stunned':
        return L('loc_ui_string_ingame_agent_hud_stunned');
      default:
    }
    return null;
  })(passiveState);

  let passiveView = null;
  if (passiveLabel) {
    passiveView = <div className={'figmaingame-characterhud-passive-state ' + passiveState} >{passiveLabel}</div>;
  }

  if (!isAlly) {
    return <div className={'figmaingame-characterhud-outer enemy' + (isIdle ? ' idle' : '') + (compact ? ' compact' : '') + (passiveState ? ' ' + passiveState : '')} style={stylepos(pos)} onClick={onClick}>
      <div className={'figmaingame-characterhud enemy' + (isIdle ? ' idle' : '')}>
        <span className='figmaingame-characterhud-name'>ENEMY {enemyId}</span>
        <div className='figmaingame-characterhud-gaugerow'>
          <div className='figmaingame-characterhud-gauge'>
            <FigmaIngameProgressBarDouble current={lifePercent} max={1} subClass={'enemy' + (isIdle ? ' idle' : '')} current2={shieldPercent} max2={1} subClass2={'enemy gear' + (isIdle ? ' idle' : '')} />
          </div>
        </div>
      </div>
      {passiveView}
      <FigmaIngameCharacterBuffs buffs={buffs} />
    </div>;
  }

  if (isDeadAlly) {
    return <div className='figmaingame-characterhud-outer compact ally dead' style={stylepos(pos)} onClick={onClick}>
      <div className='figmaingame-characterhud ally dead'>
        {svg_icon_skull}
        <div className='figmaingame-characterhud-name'>{name}</div>
      </div>
    </div>;
  }

  if (compact) {
    return <div className={'figmaingame-characterhud-outer compact ally' + (passiveState ? ' ' + passiveState : '')} style={stylepos(pos)} onClick={onClick}>
      <div className='figmaingame-characterhud ally'>
        <div className="figmaingame-characterhud-states">
          <div className="figmaingame-characterhud-state-ammo">
            <SvgIconAmmo state={state} percent={ammoPercent} />
          </div>
        </div>
        <div className="figmaingame-characterhud-details">
          <div className='figmaingame-characterhud-name'>{name}</div>
          <div className='figmaingame-characterhud-gaugerow'>
            <div className='figmaingame-characterhud-gauge'>
              <div className='figmaingame-characterhud-gauge-value'>
                <FigmaIngameProgressBarDouble current={lifePercent} limit={lifeLimit} max={1} subClass='life' current2={shieldPercent} max2={1} subClass2='gear' />
              </div>
            </div>
          </div>
        </div>
      </div>
      {passiveView}
      <FigmaIngameCharacterBuffs buffs={buffs} />
    </div>;
  }

  function NarrowGauge(props) {
    const { ty, value, reason } = props;
    return <div className={'figmaingame-characterhud-gauge' + (reason ? ' ' + reason : '')}>
      <div className='figmaingame-characterhud-gauge-desc'>
        {ty === 'armor' ? SvgIconVest((reason === 'unequipped' ? '#626262' : "#25B2BB")) : null}
        {ty === 'shield' ? SvgIconShield((reason === 'unequipped' ? '#626262' : "#25B2BB")) : null}
        <span>{(reason === 'unequipped' ? '-' : (value * 100).toFixed(0) + '%')}</span>
      </div>
      {(reason === 'unequipped' ? null : <div className='figmaingame-characterhud-gauge-value narrow'>
        <FigmaIngameProgressBar current={value} max={1} subClass='gear' />
      </div>)}
    </div>;
  }

  return <div className={'figmaingame-characterhud-outer ally' + (passiveState ? ' ' + passiveState : '')} style={stylepos(pos)} onClick={onClick}>
    <div className='figmaingame-characterhud ally'>
      <div className="figmaingame-characterhud-states">
        <div className="figmaingame-characterhud-state-ammo">
          <SvgIconAmmo state={state} percent={ammoPercent} />
        </div>
        <div className="figmaingame-characterhud-state-behaviour">
          <SvgIconState state={state} />
        </div>
      </div>
      <div className="figmaingame-characterhud-details">
        <div className='figmaingame-characterhud-name'>{name}</div>
        <div className='figmaingame-characterhud-gaugerow'>
          <div className='figmaingame-characterhud-gauge'>
            <div className='figmaingame-characterhud-gauge-value'>
              <FigmaIngameProgressBar current={lifePercent} limit={lifeLimit} max={1} subClass='life' />
            </div>
          </div>
        </div>
        {shieldReason !== 'unavailable' ?
          <div className='figmaingame-characterhud-gaugerow'>
            <NarrowGauge ty='shield' value={shieldPercent} reason={shieldReason} />
          </div>
          : null}
      </div>
    </div>
    {passiveLabel ?
      <div className={'figmaingame-characterhud-passive-state ' + passiveState} >{passiveLabel}</div>
      : null}
  </div>;
}

export function FigmaIngameCharacterBuffs(props) {
  const { buffs } = props;

  const ret = [];
  const keys = Object.keys(buffs ?? {});
  const value = Object.values(buffs ?? {});
  const text = ['데', '데', '실', '실', '회', '회', '속', '속', '명', '명', '무', '힐'];

  const len = keys.length;
  for (let i = 0; i < len; i++) {
    if (value[i] && value[i] !== 0) {
      const color = (keys[i].includes('reduction') ? 'bad' : 'good');
      // ret.push(<span className='figmaingame-agent-buff-icon'>
      //   <span className={`figmaingame-agent-buff-icon-${color}`}>{text[i]}</span>
      // </span>);
      ret.push(<img
        className='figmaingame-agent-buff-icon'
        src={`/img/ingame/icon-buff/icon-buff-${keys[i]}.png`} />);
    }
  }

  return <div className='figmaingame-agent-buff'>
    {ret}
  </div>;
}

function SvgIconSpeaker(props) {
  const { isAlly, isIdle } = props;
  return <svg xmlns="http://www.w3.org/2000/svg" width="10" height="14" viewBox="0 0 10 14" fill="none">
    <path d="M10 0L5 3.81818H0V10.1818H5L10 14V0Z" fill={isAlly ? "#99D836" : (isIdle ? "#434343" : "#E94559")} />
  </svg>;
}

function stylepos(p) {
  const { x, y } = p;
  return {
    top: y + 'px',
    left: x + 'px',
  };
}

export function FigmaIngameBubble(props) {
  const { isAlly, isIdle, message, pos } = props;
  return <div className={'figmaingame-bubble' + (isAlly ? ' ally' : (isIdle ? ' enemy idle' : ' enemy'))} style={stylepos(pos)}>
    <div className='figmaingame-bubble-bg'></div>
    <div className='figmaingame-bubble-icon'><SvgIconSpeaker isAlly={isAlly} isIdle={isIdle} /></div>
    <div className='figmaingame-bubble-message'>{message}</div>
  </div>;
}

export function FigmaIngameDirectionMarker(props) {
  const { color, angle } = props;
  let { pos } = props;

  return <div className='figmaingame-direction-marker' style={stylepos(pos)} >
    <img className='figmaingame-direction-marker-image'
      src='/img/ingame/dir_marker.png'
      alt=""
      style={{
        transform: `rotate(${angle}deg)`,
        filter: filter_color_perset[color],
      }}
    />
  </div >
}

export function FigmaIngameDamageIndication(props) {
  const { damage, pos, opacity } = props;
  return <div className={'figmaingame-damage-indication'} style={stylepos(pos)}>
    <div className='figmaingame-damage-indication-damage' style={{ opacity }}>{`${damage.toFixed(1)}`}</div>
  </div>;
}

export function FigmaIngameSpotMarker(props) {
  const { angle, img_screenpos, text_screenpos, color, dist } = props;

  const color_filter = filter_color_perset[color];

  return <div>
    <div className='figmaingame-spot-marker' style={stylepos(img_screenpos)}>
      <img className='figmaingame-spot-marker-image'
        src="/img/ingame/sspot_marker.png"
        alt=""
        style={{
          transform: `rotate(${angle}deg)`,
          filter: `${color_filter}`
        }} />
    </div>
    <div className='figmaingame-spot-marker' style={stylepos(text_screenpos)}>
      <div className='figmaingame-spot-marker-text' style={{ color: `${color}` }}>{`${(dist / 10).toFixed(1)}M`}</div>
    </div>
  </div>
}

export function FigmaIngameAlertMarker(props) {
  let { pos } = props;

  return <div className='figmaingame-alert-marker' style={stylepos(pos)} >
    <img className='figmaingame-alert-marker-image'
      src='/img/ingame/alert_marker.png'
      alt=""
      style={{
        filter: filter_color_perset['red'],
      }}
    />
  </div >
}

export function FigmaIngameDeathMarker(props) {
  const { fadeout } = props;
  let { pos } = props;

  return <div className="figmaingame-death-marker" style={stylepos(pos)}>
    <img className="figmaingame-death-marker-image"
      src='/img/ingame/death_marker.png'
      alt=""
      style={{
        filter: filter_color_perset['red'],
        opacity: fadeout,
      }}
    />
  </div>;
}

export function FigmaIngameHeadshotMarker(props) {
  const { progress } = props;
  let { pos } = props;

  const cnt = 36;
  const frame = Math.floor(cnt * progress);
  const [x, y] = [frame % 6, Math.floor(frame / 6)];

  return <div className="figmaingame-headshot-marker" style={stylepos(pos)}>
    <img className="figmaingame-headshot-marker-image"
      src='/img/ingame/headshot_marker.png'
      alt=""
      style={{
        filter: filter_color_perset['red'],
        top: `-${y * 100}px`,
        left: `-${x * 100}px`,
      }}
    />
  </div>;
}

export function FigmaIngameActionProgress(props) {
  const { pos, ty, percent } = props;

  const startAngle = 270;
  const endAngle = (startAngle - 360 * percent) % 360;

  let color = '#E5A72D';
  let shape = null;
  if (ty === 'throwable') {
    shape = <>
      <path d="m14.21,9.16l-1.41,0.81l0.46,0.8c1.75,-0.18 3.51,0.6 4.53,2.13l-8.4,4.87c-0.87,-1.74 -0.59,-3.78 0.58,-5.23l-0.78,-2.26l0.18,-0.1l0,0l4.6,-2.66l0.3,0.07c1.38,0.32 3.12,1.07 4.84,2.83l-1.1,1.07c-1.38,-1.4 -2.72,-2.04 -3.8,-2.34z" fill={color} />
      <path d="m9.95,18.65c1.48,1.86 4.13,2.4 6.24,1.18c2.12,-1.23 2.97,-3.8 2.09,-6.01l-8.34,4.83z" fill={color} />
    </>;
  } else if (ty === 'breach') {
    shape = <>
      <path d="m15.98,13.53c0.16,-0.16 0.16,-0.43 0,-0.6c-0.16,-0.16 -0.43,-0.16 -0.59,0l-1.69,1.69c-0.16,0.16 -0.16,0.43 0,0.59c0.16,0.16 0.43,0.16 0.59,0l1.69,-1.69z" fill={color} />
      <path clipRule="evenodd" d="m16.25,7.47c0.23,0 0.43,0.19 0.43,0.42l0,1.41l0.86,0l0.97,0.97l0,9.3l-0.97,0.97l-7.06,0l-0.97,-0.97l0,-9.3l0.97,-0.97l5.35,0l0,-1.41c0,-0.23 0.19,-0.42 0.42,-0.42zm-2.25,10.82c1.87,0 3.38,-1.51 3.38,-3.37c0,-1.86 -1.51,-3.37 -3.38,-3.37c-1.86,0 -3.37,1.51 -3.37,3.37c0,1.87 1.51,3.37 3.37,3.37z" fill={color} fillRule="evenodd" />
      <path d="m8.94,11.54l-1.12,0l0,1.69l1.12,0l0,-1.69z" fill={color} />
      <path d="m8.94,17.16l-1.12,0l0,1.69l1.12,0l0,-1.69z" fill={color} />
      <path d="m19.06,11.54l1.12,0l0,1.69l-1.12,0l0,-1.69z" fill={color} />
      <path d="m19.06,17.16l1.12,0l0,1.69l-1.12,0l0,-1.69z" fill={color} />
      <path d="m19.06,14.35l1.12,0l0,1.69l-1.12,0l0,-1.69z" fill={color} />
      <path d="m7.81,14.35l1.12,0l0,1.69l-1.12,0l0,-1.69z" fill={color} />
    </>;
  } else if (ty === 'heal') {
    shape = <>
      <path d="m11.31,8.84c1.23,0 2.28,0.77 2.68,1.86c0.4,-1.09 1.45,-1.86 2.68,-1.86c1.55,0 2.81,1.23 2.86,2.78l0,0.01c0,0.02 0,0.05 0,0.07l0,0c0.01,0.73 0.03,2.54 -2.09,4.63c-0.24,0.27 -0.52,0.51 -0.78,0.74c-0.17,0.14 -0.33,0.29 -0.47,0.42c-1.13,0.94 -1.84,1.66 -2.2,1.66c-0.37,0 -1.07,-0.73 -2.2,-1.66c-0.14,-0.14 -0.3,-0.28 -0.47,-0.42c-0.26,-0.23 -0.54,-0.47 -0.78,-0.74c-2.12,-2.09 -2.1,-3.9 -2.09,-4.63l0,0c0,-0.02 0,-0.05 0,-0.07l0,-0.01c0.04,-1.54 1.31,-2.78 2.86,-2.78z" fill={color} />
      <path clipRule="evenodd" d="m8.08,11.61c0.05,-1.75 1.48,-3.15 3.24,-3.15c1.12,0 2.1,0.56 2.68,1.42c0.58,-0.85 1.56,-1.42 2.68,-1.42c1.76,0 3.19,1.4 3.24,3.15l0,0l0,0.01c0,0.03 0,0.05 0,0.07l0,0c0,0.37 0.01,1.06 -0.26,1.92c-0.28,0.86 -0.83,1.89 -1.93,2.97c-0.26,0.28 -0.54,0.53 -0.8,0.75l-0.01,0.01c-0.17,0.15 -0.32,0.28 -0.46,0.41l-0.01,0.01l-0.01,0.01c-0.28,0.23 -0.53,0.45 -0.76,0.65c-0.01,0.01 -0.03,0.03 -0.04,0.04c-0.22,0.19 -0.41,0.35 -0.58,0.5c-0.19,0.15 -0.36,0.29 -0.52,0.38c-0.14,0.09 -0.33,0.19 -0.54,0.19c-0.2,0 -0.39,-0.09 -0.54,-0.19c-0.16,-0.1 -0.33,-0.23 -0.52,-0.38c-0.17,-0.14 -0.37,-0.31 -0.58,-0.5l-0.04,-0.04c-0.23,-0.2 -0.48,-0.42 -0.76,-0.65l-0.01,-0.01l-0.01,-0.01c-0.13,-0.13 -0.29,-0.26 -0.46,-0.41l-0.01,-0.01c-0.26,-0.22 -0.54,-0.47 -0.8,-0.75c-1.1,-1.08 -1.65,-2.11 -1.93,-2.97c-0.27,-0.86 -0.27,-1.55 -0.26,-1.92l0,0c0,-0.03 0,-0.05 0,-0.07l0,0l0,-0.01l0,0zm0.76,0.02c0,0 0,0 0,0l0,0.01c0,0.02 0,0.04 0,0.06l0,0l0,0c0,0.35 -0.01,0.94 0.23,1.68c0.24,0.74 0.73,1.66 1.75,2.67l0.01,0.01l0.01,0.01c0.22,0.25 0.48,0.47 0.75,0.71l0,0c0.16,0.14 0.32,0.28 0.47,0.42c0.28,0.23 0.54,0.46 0.76,0.65c0.01,0.01 0.03,0.03 0.04,0.04c0.22,0.19 0.4,0.35 0.57,0.49c0.18,0.14 0.32,0.25 0.43,0.32c0.09,0.05 0.13,0.07 0.14,0.07c0.01,0 0.06,-0.02 0.14,-0.07c0.11,-0.07 0.25,-0.17 0.43,-0.32c0.17,-0.14 0.35,-0.3 0.57,-0.49c0.01,-0.01 0.03,-0.03 0.04,-0.04c0.23,-0.2 0.48,-0.42 0.76,-0.65c0.14,-0.14 0.31,-0.28 0.47,-0.42l0,0c0.27,-0.23 0.53,-0.46 0.75,-0.71l0.01,-0.01l0.01,-0.01c1.02,-1 1.51,-1.93 1.75,-2.67c0.24,-0.75 0.23,-1.33 0.23,-1.68c0,0 0,0 0,0l0,0c0,-0.02 0,-0.04 0,-0.06c0,0 0,0 0,0l0,-0.01c-0.04,-1.33 -1.13,-2.41 -2.47,-2.41c-1.06,0 -1.97,0.67 -2.32,1.61l-0.36,0.96l-0.36,-0.96c-0.35,-0.94 -1.26,-1.61 -2.32,-1.61c-1.34,0 -2.44,1.07 -2.47,2.41z" fill={color} fillRule="evenodd" />
      <path d="m9.22,10.75l4.37,0c-0.39,-0.9 -1.22,-1.53 -2.19,-1.53c-0.96,0 -1.79,0.63 -2.18,1.53z" fill="#4C1E04" />
      <path d="m14.4,10.75l4.37,0c-0.39,-0.9 -1.22,-1.53 -2.18,-1.53c-0.96,0 -1.8,0.62 -2.19,1.53z" fill="#4C1E04" />
      <path d="m14.76,12.25l-1.53,0l0,1.53l-1.53,0l0,1.53l1.53,0l0,1.53l1.53,0l0,-1.53l1.53,0l0,-1.53l-1.53,0l0,-1.53z" fill="#4C1E04" />
    </>;
  } else if (ty === 'goal') {
    shape = <>
      <path clipRule="evenodd" d="m21.26,10.63l-9.2,9.26l-5.32,-5.25l2.5,-2.54l2.79,2.76l6.71,-6.75l2.52,2.51z" fill={color} fillRule="evenodd" />
    </>;
  }

  const gaugeBg = <circle cx="14" cy="14" r="11" stroke="black" strokeWidth="3" />;
  let newPath = null;
  if (percent > 0 && percent < 1) {
    newPath = <path d={describeArcWithStroke(14, 14, 11, startAngle, endAngle, 3)} fill={color} />;
  } else if (percent >= 1) {
    newPath = <circle cx="14" cy="14" r="11" stroke={color} strokeWidth="3" />;
  }

  const size = 28 * 2;

  return <div className="figmaingame-progress" style={stylepos(pos)}>
    <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox={`0 0 28 28`} fill="none">
      {shape}
      {gaugeBg}
      {newPath}
    </svg>
  </div>;
}

export class FigmaIngameView extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      tick: 0,
    };

    // this.timer = requestAnimationFrame(this.onTick.bind(this));
  }

  componentWillUnmount() {
    cancelAnimationFrame(this.timer);
  }

  onTick() {
    const { tick } = this.state;
    this.setState({ tick: tick + 1 });
    this.timer = requestAnimationFrame(this.onTick.bind(this));
  }

  render() {
    const { policies, characters } = this.props;
    const { segments } = this.props;

    const { tick } = this.state;

    let i = 0;
    function pos() {
      const gridsize = 200;
      const n = 6;
      const p0 = new v2(gridsize * (i % n + 1), gridsize * (Math.floor(i / n) + 1));
      const p = p0.add(new v2(0, 200 * Math.sin(tick / 20 + i * 0.5)));
      i++;
      return p;
    }

    // i18n ignore 13
    const data_hud = [
      { isAlly: false, enemyId: '1-2', lifePercent: 1, armorPercent: 0.5, shieldPercent: 0, shieldReason: 'unavailable', pos: pos(), compact: true, },
      { isAlly: false, enemyId: '11-7', lifePercent: 0.1, pos: pos() },
      { isAlly: false, enemyId: '3-4', lifePercent: 1, armorPercent: 1, shieldPercent: 0, shieldReason: 'unavailable', pos: pos(), isIdle: true, compact: true, },
      { isAlly: true, name: 'ALPHA', lifePercent: 0.7383, armorPercent: 0.45, shieldPercent: 0, shieldReason: 'unequipped', state: 'reload', ammoPercent: 0.75, pos: pos(), passiveState: 'covered', compact: true, },
      { isAlly: true, name: '볼빨간갱년기 가나다라마', lifePercent: 1, armorPercent: 0.45, shieldPercent: 0.6, state: 'aim', ammoPercent: 1, pos: pos(), compact: true, },
      { isAlly: true, name: '검단존윅', lifePercent: 0.1, armorPercent: 0.45, shieldPercent: 0, shieldReason: 'unavailable', state: 'aim', ammoPercent: 0.91, pos: pos(), passiveState: 'obstructed', compact: true, },
      { isAlly: true, name: 'BULWARK', lifePercent: 0.6, armorPercent: 0, armorReason: 'unavailable', shieldPercent: 0.9, state: 'aim', ammoPercent: 0.75, pos: pos() },
      { isAlly: true, name: 'SIGMA 6', lifePercent: 0, armorPercent: 0, shieldPercent: 0, state: 'aim', ammoPercent: 0.44, pos: pos() },
      { isAlly: true, name: 'BAREHAND', lifePercent: 1, armorPercent: 0, armorReason: 'unequipped', shieldPercent: 1, state: 'aim', ammoPercent: 0, pos: pos() },
      { isAlly: true, name: '초원의강동원', lifePercent: 1, armorPercent: 0, armorReason: 'unavailable', shieldPercent: 0, shieldReason: 'unavailable', state: 'aim', ammoPercent: 0, pos: pos(), passiveState: 'stunned', compact: true, },
      { isAlly: false, enemyId: '3-27', lifePercent: 1, armorPercent: 0.6, shieldPercent: 0, shieldReason: 'unavailable', pos: pos(), passiveState: 'stunned', compact: true, },
    ];

    const entities = characters.map((character, index) => entityAlly(character, index));
    return <div className='figmaingame-root'>
      {data_hud.map((props, i) => {
        return <>
          <FigmaIngameCharacterHudLine key={`hudline-${i}`} pos={props.pos} anchor={v2.zero()} isAlly={props.isAlly} isIdle={props.isIdle} />
          <FigmaIngameCharacterHud key={`hud-${i}`} {...props} />
        </>;
      })}
      {svg_icon_state_stun}
      <FigmaIngameBubble isAlly={true} message={'Target on sight.'} pos={pos()} />
      <FigmaIngameBubble isAlly={false} message={'Enemies approaching!'} pos={pos()} />
      <FigmaIngameBubble isAlly={true} message={'Kim sohanmoo turtles and cranes, three thousands sexagenary cycles eastern new moon.'} pos={pos()} />
      {// i18n ignore 2
      }
      <FigmaIngameBubble isAlly={false} isIdle={true} message={"한글"} pos={pos()} />
      <FigmaIngameActionProgress ty='throwable' percent={0.7} pos={pos()} />
      <FigmaIngameActionProgress ty='breach' percent={0.3} pos={pos()} />
      <FigmaIngameActionProgress ty='heal' percent={0.2} pos={pos()} />
      <FigmaIngameActionProgress ty='goal' percent={0.9} pos={pos()} />
      <FigmaIngameProgressBoard segments={segments} />
      <FigmaIngamePolicyCard policies={policies} />
      <FigmaIngameAgentList entities={entities} />
    </div>;
  }
}

